import i18n from '@/i18n'
import { getEvaluationsCountFromApi } from '@/views/reports/api'

const COLORS = {
    sent: '#359C61',
    pending: '#E7A42F',
    declined: '#DE5B5B',
    unanswered: '#6E6E6E',
}

export default {
    props: {
        filters: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            colors: { ...COLORS },
            labels: {
                sent: {
                    id: 'sent',
                    color: COLORS.sent,
                    text: i18n.t('values.evaluationStatuses.sent'),
                },
                pending: {
                    id: 'pending',
                    color: COLORS.pending,
                    text: i18n.t('values.evaluationStatuses.pending'),
                },
                declined: {
                    id: 'declined',
                    color: COLORS.declined,
                    text: i18n.t('values.evaluationStatuses.declined'),
                },
                unanswered: {
                    id: 'unanswered',
                    color: COLORS.unanswered,
                    text: i18n.t('values.evaluationStatuses.unanswered'),
                },
            },
        }
    },
    mounted() {
        this.getEvaluationsCount()
    },
    watch: {
        filters() {
            this.getEvaluationsCount()
        },
    },
    methods: {
        getEvaluationsCount() {
            getEvaluationsCountFromApi(this.filters, this.type)
                .then(res => {
                    this.setEvaluationsCount(res)
                })
                .catch(e => {
                    console.log(e)
                })
        },
        mapToSelectedProperty(arrayOfObjects, propertyToExtract) {
            return arrayOfObjects.map(e => e[propertyToExtract])
        },
        mapDataset(values) {
            return [
                {
                    name: this.labels.sent.text,
                    data: this.mapToSelectedProperty(values, 'sent'),
                },
                {
                    name: this.labels.pending.text,
                    data: this.mapToSelectedProperty(values, 'pending'),
                },
                {
                    name: this.labels.declined.text,
                    data: this.mapToSelectedProperty(values, 'declined'),
                },
                {
                    name: this.labels.unanswered.text,
                    data: this.mapToSelectedProperty(values, 'unanswered'),
                },
            ]
        },
    },
}
